import { useRef as c, useEffect as n } from "react";
function s(r, t) {
  const e = c(void 0);
  n(() => {
    e.current = r;
  }, [r]), n(() => {
    if (t === null)
      return;
    function u() {
      e.current();
    }
    const o = setInterval(u, t);
    return () => clearInterval(o);
  }, [t]);
}
export {
  s as u
};
